import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import OutboxOutlinedIcon from "@mui/icons-material/OutboxOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";

// Fonte única de verdade dos itens de menu, consumida por Sidebar e BottomNav.
// Paths/nomes de permissão reaproveitados literalmente do antigo `Navbar`
// (removido na Fase 6) — nome da rota == nome da permissão,
// convenção usada pelo guard `Private` em src/routes/index.js.
//
// Agrupamento em 3 níveis conforme Seção 10.4 da ux-design-specification.md
// e Design Notes da spec-fase-1-tema-shell.md:
// - tier 1: sempre visível (sidebar + bottom nav mobile)
// - tier 2: "Estoque" (sidebar; agrupado sob "Mais" no mobile)
// - tier 3: "Financeiro + Utilitários" (sidebar; agrupado sob "Mais" no mobile)
export const menuItems = [
  { label: "Home", path: "home", icon: HomeOutlinedIcon, tier: 1 },
  {
    label: "Frente de Caixa - Loja",
    path: "frenteCaixaLoja",
    icon: PointOfSaleOutlinedIcon,
    tier: 1,
  },
  {
    label: "Frente de Caixa - Galpão",
    path: "frenteCaixaGalpao",
    icon: WarehouseOutlinedIcon,
    tier: 1,
  },
  {
    label: "Entrada Manual",
    path: "entradaManual",
    icon: MoveToInboxOutlinedIcon,
    tier: 2,
    group: "Estoque",
  },
  {
    label: "Saída Manual",
    path: "saidaManual",
    icon: OutboxOutlinedIcon,
    tier: 2,
    group: "Estoque",
  },
  {
    label: "Nota Fiscal de Entrada",
    path: "uploadNFE",
    icon: ReceiptLongOutlinedIcon,
    tier: 2,
    group: "Estoque",
  },
  {
    label: "Caixa",
    path: "fluxoCaixa",
    icon: AccountBalanceWalletOutlinedIcon,
    tier: 3,
    group: "Financeiro",
  },
  {
    label: "Fechamento Diário",
    path: "fechamentoDiario",
    icon: EventAvailableOutlinedIcon,
    tier: 3,
    group: "Financeiro",
  },
  {
    label: "Disponibilidade",
    fullLabel: "Relatório de Disponibilidade",
    path: "relatorioDisponibilidade",
    icon: AssessmentOutlinedIcon,
    tier: 3,
    group: "Financeiro",
  },
  {
    label: "Movim. Produto",
    fullLabel: "Histórico de Movimentações de Produto",
    path: "relHistMovimentacaoProd",
    icon: HistoryOutlinedIcon,
    tier: 3,
    group: "Financeiro",
  },
  {
    label: "Conversor ZPL",
    path: "conversorZpl",
    icon: QrCode2OutlinedIcon,
    tier: 3,
    group: "Utilitários",
  },
  {
    label: "Adm. Usuários",
    fullLabel: "Administração de Usuários",
    path: "admUsuarios",
    icon: ManageAccountsOutlinedIcon,
    tier: 3,
    group: "Utilitários",
  },
  {
    label: "Auditoria NF-e",
    fullLabel: "Auditoria de Notas Fiscais",
    path: "auditoriaNotasFiscais",
    icon: FactCheckOutlinedIcon,
    tier: 3,
    group: "Utilitários",
  },
  {
    label: "Tokens das Lojas",
    fullLabel: "Gerenciamento de Tokens das Lojas",
    path: "gerenciamentoLojasTokens",
    icon: VpnKeyOutlinedIcon,
    tier: 3,
    group: "Utilitários",
  },
];
